import React from 'react'
import PropTypes from 'prop-types'
import styles from './TableSlatePlugin.scss'
import { UncontrolledTooltip, ButtonGroup, Button } from 'reactstrap'
import EditorTooltip from '../EditorTooltip'
import { FaTrash } from 'react-icons/lib/fa'
import InsertEmptySpaceButton from '../InsertEmptySpaceButton'
import * as TablePosition from './deep-table-plugin/TablePosition'

class DeepTableRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.uid = Date.now()
  }

  getCurrentRow = state => {
    return state.document.getClosest(
      state.startBlock.key,
      (p) => (p.type === this.props.opts.typeRow)
    )
  }

  render () {
    const { actions, attributes, node, children, readOnly, state, editor, opts } = this.props
    const { onChange } = editor
    const pos = TablePosition.create(state, state.startBlock, opts)
    const closestRow = this.getCurrentRow(state)
    const focusedOnCurrentNode = closestRow && node.key === closestRow.key
    const showTooltip = !readOnly && focusedOnCurrentNode
    const uid = 'DeepTableRow' + this.uid
    return <tr {...attributes} id={uid} className={styles.DeepTableRow}>
      <EditorTooltip state={state} placement='top'
        className={styles.TableActionsTooltip} isOpen={showTooltip}
        tetherRef={this.getTetherRef} target={uid} toggle={this.toggle}>
        <div>
          <ButtonGroup style={{marginBottom: '10px'}}>
            <Button
              onClick={e => onChange(actions.onInsertRow(e, state))}
              color='secondary'
              > <strong>Insert</strong> row
            </Button>
            <Button
              onClick={e => onChange(actions.onRemoveRow(e, state))}
              color='secondary'
              > <strong>Remove</strong> row
            </Button>
          </ButtonGroup>
          <br />
          <ButtonGroup style={{marginBottom: '10px'}}>
            <Button
              onClick={e => onChange(actions.onInsertColumn(e, state))}
              color='secondary'
              > <strong>Insert</strong> column
            </Button>
            <Button
              onClick={e => onChange(actions.onRemoveColumn(e, state))}
              color='secondary'
              > <strong>Remove</strong> column
            </Button>
          </ButtonGroup>
          <br />
          <ButtonGroup>
            {
              pos.table && (pos.isFirstRow() || pos.isLastRow()) &&
              <InsertEmptySpaceButton
                before={pos.isFirstRow()}
                after={pos.isLastRow()}
                block={pos.table}
                state={state}
                onChange={onChange} />
            }
            <Button id={uid + 'trash'} onClick={e => onChange(actions.onRemoveTable(e, state))} color='danger'><FaTrash /></Button>
            <UncontrolledTooltip target={uid + 'trash'}>Remove Table</UncontrolledTooltip>
          </ButtonGroup>
        </div>
      </EditorTooltip>
      {children}
    </tr>
  }
}

DeepTableRow.propTypes = {
  opts: PropTypes.object,
  actions: PropTypes.object,
  readOnly: PropTypes.bool,
  node: PropTypes.object,
  state: PropTypes.object,
  editor: PropTypes.object,
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default DeepTableRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/DeepTableRow.js